import React from "react"
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material"

import { ACRISS_GROUP_BY_OPTIONS } from "@constants"
import { acrissGroupBy, offices } from "@signals"
import { oneWayData, oneWayPriceMode } from "Pages/AnalyzersV2/OneWay/@signals"
import { oneWayAxisLabel } from "./axis"

export default function OneWayTableTitle() {
	const pickupName = oneWayData.value?.pickupName
	const dropoffName = oneWayData.value?.dropoffName
	const groupByLabel = ACRISS_GROUP_BY_OPTIONS.find(x => x.value === acrissGroupBy.value)?.label ?? 'acriss'
	const axisLabel = oneWayAxisLabel().toLowerCase()

	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
		<Box>
			<Typography variant="title">One Way Fee</Typography>
			<Typography variant="body2" sx={{ color: 'secondary.main' }}>
				Minimum one-way fee per matched car ({pickupName ?? 'pickup'}-{dropoffName ?? 'dropoff'} minus {pickupName ?? 'pickup'}-{pickupName ?? 'pickup'}, same provider, car, site, date and LOR), per {axisLabel} and grouped by {groupByLabel.toLowerCase()}.
			</Typography>
		</Box>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
			<FormControlLabel
				control={
					<Checkbox
						size="small"
						checked={oneWayPriceMode.value === 'roundTrip'}
						onChange={e => oneWayPriceMode.value = e.target.checked ? 'roundTrip' : 'oneWay'}
					/>
				}
				label={<Typography variant="body2">Round Trip Price</Typography>}
			/>
			{!!offices.value && <Typography variant="subtitle2" sx={{ color: 'secondary.main' }}>
				Baseline: same office as pickup
			</Typography>}
		</Box>
	</Box>
}